import { useEffect, useRef } from 'react';

export function clampPage(page: number, total: number, pageSize: number): number {
  const maxPage = Math.max(1, Math.ceil(total / pageSize));
  return Math.min(page, maxPage);
}

// Rewrite a stale page only after real data arrives.
export function usePageClamp({
  page,
  pageSize,
  total,
  ready,
  setPage,
}: {
  page: number;
  pageSize: number;
  total: number | undefined;
  ready: boolean;
  setPage: (page: number) => void;
}): void {
  const setPageRef = useRef(setPage);
  setPageRef.current = setPage;

  useEffect(() => {
    if (!ready || total === undefined) return;
    const nextPage = clampPage(page, total, pageSize);
    if (nextPage < page) setPageRef.current(nextPage);
  }, [page, pageSize, ready, total]);
}
